<template>
  <div id="declarante_e_testemunha">
    <div v-b-toggle="id"
         class="cursor"
         :class="[{'resumo-show_header--grey': styleDefault, 'mt-3': paddingDefault}, headerClass ? headerClass : '']">
      <span v-if="condition && iconPosition == 'left' && iconsShow == true"
            class="when-opened">
        <icon-svg :class="iconsClass"
                  icon="arrowDown" />
      </span>
      <span v-if="condition && iconPosition == 'left' && iconsShow == true"
            class="when-closed">
        <icon-svg :class="iconsClass"
                  icon="arrowRight" />
      </span>

      <span>
        <slot name="header" />
      </span>

      <span v-if="condition && iconPosition == 'right' && iconsShow == true"
            class="when-opened">
        <icon-svg :class="iconsClass"
                  icon="arrowDown" />
      </span>
      <span v-if="condition && iconPosition == 'right' && iconsShow == true"
            class="when-closed">
        <icon-svg :class="iconsClass"
                  icon="arrowRight" />
      </span>
    </div>

    <b-collapse :id="id"
                :visible="collapseVisible"
                @show="$emit('onCollapseShow')">
      <slot name="content" />
    </b-collapse>
  </div>
</template>

<script>
  //icones para collapse
  import icon_arrow_down from "@/assets/icons/arrow-down.svg?sprite"
  import icon_arrow_right from "@/assets/icons/arrow-right.svg?sprite"

  export default {
    name: "CollapseDefault",
    props: {
      id: String,
      //condition é usado para mostrar as setas do collapse caso tenha ou não conteúdo
      condition: {
        type: [Boolean, Number, Object],
        default: true
      },
      //collapseVisible é usado para o collapse vir aberto ou não
      collapseVisible: {
        type: [Boolean, Number],
        default: false
      },
      //styleDefault é usado para usar a class de header-grey ou não
      styleDefault: {
        type: Boolean,
        default: true
      },
      //paddingDefault é usado para usar a class de mt-3 ou não
      paddingDefault: {
        type: Boolean,
        default: true
      },
      //styleDefault é usado para usar a class de header-grey ou não
      iconPosition: {
        type: String,
        default: "right"
      },
      iconsShow: {
        type: Boolean,
        default: true
      },
      headerClass: {
        type: String,
        default: ''
      },
      iconsClass: {
        type: String,
        default: 'icons--black icon--xxs'
      }
    },
    data () {
      return {
        icons: {
          icon_arrow_down: icon_arrow_down,
          icon_arrow_right: icon_arrow_right,
        },
      }
    },
  }
</script>

<style scoped>
  .cursor {
    cursor: pointer;
  }
</style>
